import { apiPost } from '@/auth/api-client';
export async function importBudgetsToCloud(budgets) {
    return apiPost('/api/v1/import/budgets', { budgets });
}
